"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1384],{

/***/ 99361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Archive; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/ui/Lecturer/Lecturer.tsx + 1 modules
var Lecturer = __webpack_require__(58596);
// EXTERNAL MODULE: ./src/ui/Package/Package.tsx + 1 modules
var Package = __webpack_require__(42420);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/ui/Spinner/Spinner.tsx + 1 modules
var Spinner = __webpack_require__(77368);
// EXTERNAL MODULE: ./src/utils/person.utils.ts
var person_utils = __webpack_require__(19033);
// EXTERNAL MODULE: ./src/utils/time.utils.ts
var time_utils = __webpack_require__(775);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/constants/packages.ts
var constants_packages = __webpack_require__(31828);
// EXTERNAL MODULE: ./src/services/calendar.service.ts
var calendar_service = __webpack_require__(2253);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Archive/Archive.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Archiveelements__Wrapper",
  componentId: "sc-dyeh0v-0"
})(["padding:", " 0;@media (min-width:", "px){padding:", " 0;}"], (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(40));
var Items = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Archiveelements__Items",
  componentId: "sc-dyeh0v-1"
})(["margin-top:", ";@media (min-width:", "px){display:flex;justify-content:space-between;flex-wrap:wrap;}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.md */.A.md);
var Item = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
  displayName: "Archiveelements__Item",
  componentId: "sc-dyeh0v-2"
})(["display:flex;flex-direction:column;margin-bottom:", ";cursor:pointer;align-items:center;position:relative;gap:", ";@media (min-width:", "px){flex-direction:row;align-items:flex-start;gap:", ";}@media (min-width:", "px){flex-direction:column;}"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(15), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.md */.A.md);
var ImageSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Archiveelements__ImageSection",
  componentId: "sc-dyeh0v-3"
})(["position:relative;"]);
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Archiveelements__Image",
  componentId: "sc-dyeh0v-4"
})(["width:", ";height:auto;opacity:0.8;border-radius:", ";"], (0,polished_esm/* rem */.hO)(320), (0,polished_esm/* rem */.hO)(12));
var Topic = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Archiveelements__Topic",
  componentId: "sc-dyeh0v-5"
})(["width:", ";display:flex;flex-direction:column;@media (min-width:", "px){width:100%;}@media (min-width:", "px){width:", ";height:100%;}"], (0,polished_esm/* rem */.hO)(320), theme/* breakpoints.sm */.A.sm, theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(320));
var TopicTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Archiveelements__TopicTitle",
  componentId: "sc-dyeh0v-6"
})(["font-size:", ";font-weight:", ";color:", ";display:block;line-height:", ";text-decoration:none;line-clamp:1;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h6;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.black;
}, (0,polished_esm/* rem */.hO)(27));
var TopicTime = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Archiveelements__TopicTime",
  componentId: "sc-dyeh0v-7"
})(["font-size:", ";color:", ";padding:", " 0;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.textBase;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.secondaryGrey;
}, (0,polished_esm/* rem */.hO)(10));
var TopSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Archiveelements__TopSection",
  componentId: "sc-dyeh0v-8"
})([""]);
var Tags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Archiveelements__Tags",
  componentId: "sc-dyeh0v-9"
})(["position:absolute;bottom:", ";left:", ";right:", ";display:flex;flex-direction:row;flex-wrap:wrap;gap:", ";"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(8));
var Tag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Archiveelements__Tag",
  componentId: "sc-dyeh0v-10"
})(["font-size:", ";color:", ";padding:", " ", ";border-radius:", ";border:1px solid ", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSizes.textSmall;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(2), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(12), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.white;
});
var Packages = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Archiveelements__Packages",
  componentId: "sc-dyeh0v-11"
})(["display:flex;margin:", " 0 ", " 0;align-items:center;gap:", ";font-size:", ";"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(4), function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSizes.textBase;
});
var ShowMore = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Archiveelements__ShowMore",
  componentId: "sc-dyeh0v-12"
})(["display:flex;justify-content:center;"]);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Archive/Archive.tsx


















var COUNT_OF_EVENTS_ON_PAGE = 3;

var ArchiveTemplate = function ArchiveTemplate(_ref) {
  var data = _ref.videos,
      count = _ref.count;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)(data),
      videos = _useState[0],
      setVideos = _useState[1];

  var _useState2 = (0,react.useState)(count),
      totalCount = _useState2[0],
      setTotalCount = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isLoading = _useState3[0],
      setIsLoading = _useState3[1];

  var showMore = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _yield$calendarApi$ge, data;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.next = 3;
              return calendar_service/* calendarApi.getArchiveVideos */.w.getArchiveVideos((videos === null || videos === void 0 ? void 0 : videos.length) + COUNT_OF_EVENTS_ON_PAGE);

            case 3:
              _yield$calendarApi$ge = _context.sent;
              data = _yield$calendarApi$ge.data;
              setVideos(data === null || data === void 0 ? void 0 : data.results);
              setTotalCount(data === null || data === void 0 ? void 0 : data.totalCount);
              setIsLoading(false);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function showMore() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      isBlack: true,
      children: t('homepage.archive.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Items, {
      children: videos === null || videos === void 0 ? void 0 : videos.map(function (video, videoKey) {
        var _video$video, _video$video$frame, _video$course, _video$video2, _video$tags, _video$tags$filter, _video$lectors, _video$course2, _video$modules, _video$modules2;

        var frameKey = video === null || video === void 0 ? void 0 : (_video$video = video.video) === null || _video$video === void 0 ? void 0 : (_video$video$frame = _video$video.frame) === null || _video$video$frame === void 0 ? void 0 : _video$video$frame.split('/')[0];
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(Item, {
          href: "".concat(constants/* ROUTES.TRAINING */.Z6.TRAINING, "/").concat(video === null || video === void 0 ? void 0 : (_video$course = video.course) === null || _video$course === void 0 ? void 0 : _video$course.slug),
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ImageSection, {
            children: [video !== null && video !== void 0 && (_video$video2 = video.video) !== null && _video$video2 !== void 0 && _video$video2.frame && frameKey ? /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
              src: "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/video/").concat(frameKey, "/frame")
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
              src: (0,url_utils/* publicAssets */.VK)('/video_default.jpg')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tags, {
              children: video === null || video === void 0 ? void 0 : (_video$tags = video.tags) === null || _video$tags === void 0 ? void 0 : (_video$tags$filter = _video$tags.filter(function (tag) {
                return tag;
              })) === null || _video$tags$filter === void 0 ? void 0 : _video$tags$filter.map(function (tag, key) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(Tag, {
                  children: tag === null || tag === void 0 ? void 0 : tag.title
                }, key);
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Topic, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TopSection, {
              children: [video === null || video === void 0 ? void 0 : (_video$lectors = video.lectors) === null || _video$lectors === void 0 ? void 0 : _video$lectors.map(function (person, personKey) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(Lecturer/* default */.Z, {
                  image: "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/people/").concat(person === null || person === void 0 ? void 0 : person.photo),
                  name: (0,person_utils/* formatLecturerName */.v)(person)
                }, personKey);
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TopicTitle, {
                children: video === null || video === void 0 ? void 0 : (_video$course2 = video.course) === null || _video$course2 === void 0 ? void 0 : _video$course2.title
              }), (video === null || video === void 0 ? void 0 : (_video$modules = video.modules) === null || _video$modules === void 0 ? void 0 : _video$modules.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Packages, {
                children: [t('homepage.archive.subscription'), ":", video === null || video === void 0 ? void 0 : (_video$modules2 = video.modules) === null || _video$modules2 === void 0 ? void 0 : _video$modules2.map(function (module, key) {
                  var subscriptionPackage = constants_packages/* SUBSCRIPTION_PACKAGES.find */.QG.find(function (subPackage) {
                    return subPackage.key === module._key;
                  });
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Package/* default */.Z, {
                      color: subscriptionPackage.color,
                      symbol: subscriptionPackage.icon
                    })
                  }, key);
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TopicTime, {
                children: [t('homepage.archive.duration'), ":", ' ', (0,time_utils/* parseHourAndMinutes */.lT)(Number(video.video.duration)), ' ']
              })]
            })
          })]
        }, videoKey);
      })
    }), (videos === null || videos === void 0 ? void 0 : videos.length) < totalCount && /*#__PURE__*/(0,jsx_runtime.jsx)(ShowMore, {
      children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {
        size: 32
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        onClick: showMore,
        whiteType: true,
        text: t('homepage.calendar.button')
      })
    })]
  });
};

/* harmony default export */ var Archive = (ArchiveTemplate);

/***/ }),

/***/ 67450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Exhibitors_Exhibitors; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/utils/person.utils.ts
var person_utils = __webpack_require__(19033);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/services/lecturer.service.ts
var lecturer_service = __webpack_require__(4034);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Exhibitors/Exhibitors.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Exhibitorselements__Wrapper",
  componentId: "sc-1deaujm-0"
})(["padding:", " 0 ", " 0;"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(60));
var Exhibitors = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Exhibitorselements__Exhibitors",
  componentId: "sc-1deaujm-1"
})(["padding:", " 0;"], (0,polished_esm/* rem */.hO)(20));
var Exhibitor = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Exhibitorselements__Exhibitor",
  componentId: "sc-1deaujm-2"
})(["display:flex;flex-direction:column;width:100%;padding:0;margin-bottom:", ";cursor:pointer;@media (min-width:", "px){margin-left:", ";}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(30));
var ExhibitorTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Exhibitorselements__ExhibitorTitle",
  componentId: "sc-1deaujm-3"
})(["padding:", " 0 ", " 0;font-weight:", ";text-align:center;width:", ";@media (min-width:", "px){width:", ";}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(145), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(170));
var ExhibitorAnnotation = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Exhibitorselements__ExhibitorAnnotation",
  componentId: "sc-1deaujm-4"
})(["color:", ";display:block;text-align:center;line-height:1.5;width:", ";@media (min-width:", "px){width:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(145), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(170));
var ExhibitorImage = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
  displayName: "Exhibitorselements__ExhibitorImage",
  componentId: "sc-1deaujm-5"
})(["width:", ";height:", ";border-radius:", ";object-fit:cover;@media (min-width:", "px){width:", ";height:", ";}"], (0,polished_esm/* rem */.hO)(145), (0,polished_esm/* rem */.hO)(210), (0,polished_esm/* rem */.hO)(16), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(170), (0,polished_esm/* rem */.hO)(240));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Exhibitors/Exhibitors.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var ExhibitorsTemplate = function ExhibitorsTemplate() {
  var _lecturers$sort;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)([]),
      lecturers = _useState[0],
      setLecturers = _useState[1];

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: false,
    responsive: [{
      breakpoint: 320,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false
      }
    }, {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false
      }
    }]
  };
  (0,react.useEffect)(function () {
    lecturer_service/* lecturerApi.list */.r.list().then(function (_ref) {
      var data = _ref.data;
      setLecturers(data.results);
    });
  }, []);
  return (lecturers === null || lecturers === void 0 ? void 0 : lecturers.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
      withPadding: true,
      mobileSidePadding: 20,
      id: "vyberLektorov",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        isBlack: true,
        children: t('homepage.lecturer.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Exhibitors, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, _objectSpread(_objectSpread({}, settings), {}, {
          children: lecturers === null || lecturers === void 0 ? void 0 : (_lecturers$sort = lecturers.sort(function (a, b) {
            return a.in_carousel - b.in_carousel;
          })) === null || _lecturers$sort === void 0 ? void 0 : _lecturers$sort.map(function (lecturer, key) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(Exhibitor, {
              onClick: function onClick() {
                return router.push("".concat(constants/* ROUTES.LECTURER */.Z6.LECTURER, "/").concat(lecturer.slug));
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ExhibitorImage, {
                width: 0,
                height: 0,
                alt: (0,person_utils/* formatLecturerName */.v)(lecturer),
                loader: function loader(_ref2) {
                  var src = _ref2.src;
                  return src;
                },
                src: lecturer.photo ? "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/people/").concat(lecturer._key) : "".concat((0,url_utils/* publicAssets */.VK)('/avatar_height.jpg'))
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ExhibitorTitle, {
                children: [lecturer.name, " ", lecturer.surname]
              }), (lecturer === null || lecturer === void 0 ? void 0 : lecturer.position) && /*#__PURE__*/(0,jsx_runtime.jsx)(ExhibitorAnnotation, {
                children: lecturer.position
              })]
            }, key);
          })
        }))
      })]
    })
  });
};

/* harmony default export */ var Exhibitors_Exhibitors = (ExhibitorsTemplate);

/***/ }),

/***/ 59922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40238);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49642);





var useScrollToSection = function useScrollToSection(sectionNameInPathname, sectionIdInHtml, spacing) {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (router.asPath.includes(sectionNameInPathname)) {
      var element = document.getElementById(sectionIdInHtml);
      return window.scrollTo({
        top: element.offsetTop - (window.innerWidth > _styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints.sm */ .A.sm ? _constants__WEBPACK_IMPORTED_MODULE_2__/* .DESKTOP_HEADER_HEIGHT */ .cf : _constants__WEBPACK_IMPORTED_MODULE_2__/* .MOBILE_HEADER_HEIGHT */ .ZQ) - (spacing || 0),
        behavior: 'smooth'
      });
    }
  }, []);
};

/* harmony default export */ __webpack_exports__["Z"] = (useScrollToSection);

/***/ }),

/***/ 4034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ lecturerApi; }
/* harmony export */ });
/* harmony import */ var _core_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84107);

var LIST = 'person/list/carousel';
var DETAIL = 'pv/person/slug';
var lecturerApi = {
  list: function list() {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LIST);
  },
  detail: function detail(slug) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug));
  },
  upcomingTrainings: function upcomingTrainings(slug, limit, offset, excludeEvents) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/upcoming/courses"), {
      limit: limit,
      offset: offset,
      excludeEvents: excludeEvents
    });
  },
  upcomingConferences: function upcomingConferences(slug, limit, offset) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/upcoming/conferences"), {
      limit: limit,
      offset: offset
    });
  },
  records: function records(slug, limit, offset, excludeEvents) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/archived/courses"), {
      limit: limit,
      offset: offset,
      excludeEvents: excludeEvents
    });
  }
};

/***/ }),

/***/ 83297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TitleTagTypes; },
  "C": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.element.tsx



var TitleStyles = (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";line-height:", ";font-weight:", ";font-family:", ";padding:", ";", ";", ";@media (min-width:", "px){font-size:", ";line-height:", ";", ";padding:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h4;
}, (0,polished_esm/* rem */.hO)(40), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (prop) {
  return prop.$withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0");
}, function (prop) {
  return prop.$isBlack ? "color: ".concat(prop.theme.colors.black, ";") : "color: ".concat(prop.theme.colors.primary, ";");
}, function (prop) {
  return prop.$alignCenter ? 'text-align: center;' : '';
}, theme/* breakpoints.sm */.A.sm, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h3;
}, (0,polished_esm/* rem */.hO)(44), function (prop) {
  return prop.$alignLeft ? 'text-align: left;' : 'text-align: center;';
}, function (prop) {
  return prop.$withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(15), " 0 ").concat((0,polished_esm/* rem */.hO)(60), " 0");
});
var WrapperDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Titleelement__WrapperDiv",
  componentId: "sc-s8z71i-0"
})(["", ""], TitleStyles);
var WrapperH1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Titleelement__WrapperH1",
  componentId: "sc-s8z71i-1"
})(["", ""], TitleStyles);
var WrapperH2 = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "Titleelement__WrapperH2",
  componentId: "sc-s8z71i-2"
})(["", ""], TitleStyles);
var WrapperH3 = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Titleelement__WrapperH3",
  componentId: "sc-s8z71i-3"
})(["", ""], TitleStyles);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.tsx



var TitleTagTypes;

(function (TitleTagTypes) {
  TitleTagTypes["H1"] = "h1";
  TitleTagTypes["H2"] = "h2";
  TitleTagTypes["H3"] = "h3";
})(TitleTagTypes || (TitleTagTypes = {}));

var TitleTemplate = function TitleTemplate(_ref) {
  var children = _ref.children,
      alignLeft = _ref.alignLeft,
      alignCenter = _ref.alignCenter,
      withoutPadding = _ref.withoutPadding,
      isBlack = _ref.isBlack,
      tagType = _ref.tagType;

  if (tagType === TitleTagTypes.H1) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH1, {
      $withoutPadding: withoutPadding,
      $alignLeft: alignLeft,
      $alignCenter: alignCenter,
      $isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H3) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH3, {
      $withoutPadding: withoutPadding,
      $alignLeft: alignLeft,
      $alignCenter: alignCenter,
      $isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H2) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH2, {
      $withoutPadding: withoutPadding,
      $alignLeft: alignLeft,
      $alignCenter: alignCenter,
      $isBlack: isBlack,
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperDiv, {
    $withoutPadding: withoutPadding,
    $alignLeft: alignLeft,
    $alignCenter: alignCenter,
    $isBlack: isBlack,
    children: children
  });
};

/* harmony default export */ var Title = (TitleTemplate);

/***/ })

}]);